import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Animatespin, Talentcard, HeadingCom } from "../../components/index";
import localimgpath from "../../js/localimgpath";
import TalnetbgImageData from "../../js/talnetbgImageData";
import Functions from "./index.function";
const Talent = () => {
  const { isLoading, talentList, handleTalent, settings } = Functions();
  return (
    <div className="bg-primary">
      <div className="xs:px-3 xs:py-5 sm:py-6 sm:px-5 lg:pt-10 lg:pb-12 xl:px-10">
        <HeadingCom title={"Talent"} to={"/talent"} />
      </div>
      <div>
        {isLoading === true ? (
          <Animatespin />
        ) : (
          <div className="pl-3 sm:pl-5 xl:pl-10">
            {talentList?.talent?.length < 1 && (
              <div className="flex items-center justify-center w-full">
                <p className="text-secondary">No talent available</p>
              </div>
            )}

            <Slider {...settings}>
              {talentList?.talent?.map((value, index) => (
                <Talentcard
                  key={index}
                  onClick={() => handleTalent(value?.id)}
                  backgroundImage={
                    TalnetbgImageData[index % TalnetbgImageData.length]
                      .backgroundImage
                  }
                  image={`${localimgpath.talentThumbnail}/${value?.hero_image}`}
                  title={
                    <>
                      {value?.real_name.split(" ")[0]} <br />{" "}
                      {value?.real_name.split(" ")[1]}
                    </>
                  }
                  realName={value?.real_name}
                  desiredJobTypes={value?.desired_job_types?.slice(0, 2)} 
                  backgroundImageClass={`xs:w-[9rem] sm:w-44 lg:w-[14rem] xl:w-[20rem] 2xl:w-[22rem] 2xl-wide:w-[24rem] 3xl:w-[26rem]`}
                  Talentcardlayout={`xs:w-[9rem] xs:h-[12rem] sm:w-44 sm:h-60 lg:w-[14rem] lg:h-[20rem] xl:w-[20rem] xl:h-[20rem] 2xl:w-[22rem] 2xl:h-[30rem] 2xl-wide:w-[24rem] 2xl-wide:h-[32rem] 3xl:w-[26rem] 3xl:h-[35rem]`}
                />
              ))}
            </Slider>
          </div>
        )}
      </div>
    </div>
  );
};

export default Talent;
